import React, { useState, useMemo, useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import CapabilityTree from './CapabilityTree';
import CapabilityPicker from './CapabilityPicker';
import { SelectorContext } from './SelectorContext';
import { Button } from 'reactstrap';
import SelectedCapabilities from './SelectedCapabilities';
import styles from './CapabilitySelector.module.scss';

export function CapabilitySelector({
  capabilitySets,
  selectedCapabilities,
  isOpen,
  onClose,
  onSelectCapability = () => {},
  onDeselectCapability = () => {},
  onSelectCapabilities = () => {},
  onDeselectCapabilities = () => {},
}) {
  return isOpen ? (
    <CapabilitySelectorInternals
      capabilitySets={capabilitySets}
      selectedCapabilities={selectedCapabilities}
      onClose={onClose}
      onSelectCapability={onSelectCapability}
      onDeselectCapability={onDeselectCapability}
      onSelectCapabilities={onSelectCapabilities}
      onDeselectCapabilities={onDeselectCapabilities}
    />
  ) : null;
}

export function CapabilitySelectorInternals({
  capabilitySets,
  selectedCapabilities,
  onClose = () => {},
  onSelectCapability = () => {},
  onDeselectCapability = () => {},
  onSelectCapabilities = () => {},
  onDeselectCapabilities = () => {},
}) {
  const [activeItem, setActiveItem] = useState(null);
  // const [capabilitySet, setCapabilitySet] = useState(null);

  // useEffect(() => {
  //   setCapabilitySet(page.capabilitySet);
  // }, [page]);

  // (cs) => {
  //   doc.transact(() => {
  //     // TODO: Refresh the cache for the capability set if necessary
  //     const sourceCapabilitySet = capabilitySets.find(
  //       (sourceSet) => sourceSet.id === cs.id
  //     );

  //     if (sourceCapabilitySet) {
  //       updateCacheForCapabilitySet(sourceCapabilitySet);
  //     }

  //     updatePageFields(page.guid, {
  //       capabilitySetId: cs.id,
  //     });
  //   });
  // },
  // [capabilitySets, doc, page, updateCacheForCapabilitySet, updatePageFields]

  const handleNavigateToItem = useCallback((item) => {
    setActiveItem(item);
  }, []);

  const capabilitySet = useMemo(() => {
    // return cachedCapabilitySets?.[page.capabilitySetId];
    return capabilitySets[0];
  }, [capabilitySets]);

  // useEffect(() => {
  //   if (
  //     (activeItem?.capabilitySet?.id ??
  //       activeItem?.capability?.capability_set_id) !== capabilitySet?.id &&
  //     capabilitySet
  //   ) {
  //     setActiveItem({ capabilitySet: capabilitySet, path: [] });
  //   }
  // }, [
  //   capabilitySet,
  //   activeItem?.capabilitySet?.id,
  //   activeItem?.capability?.capability_set_id,
  // ]);

  // console.log('🚧 capabilitySet', capabilitySet, cachedCapabilitySets, page);
  // console.log('🚧 cachedCapabilitySets', cachedCapabilitySets);

  // const selectedCapabilities = useMemo(() => {
  //   return Object.entries(page.selectedCapabilities).reduce((acc, [id]) => {
  //     if (
  //       true ||
  //       assessment.capabilityCache[id]?.capability_set_id ===
  //         page.capabilitySetId
  //     ) {
  //       acc[id] = assessment.capabilityCache[id];
  //     }
  //     return acc;
  //   }, {});
  // }, [
  //   page.selectedCapabilities,
  //   page.capabilitySetId,
  //   assessment.capabilityCache,
  // ]);

  const selectorContext = useMemo(() => {
    return {
      navigateToItem: handleNavigateToItem,
      activeItem,
      selectedCapabilities,
      capabilitySet,
      capabilitySets,
      selectCapability: onSelectCapability,
      deselectCapability: onDeselectCapability,
      selectCapabilities: onSelectCapabilities,
      deselectCapabilities: onDeselectCapabilities,
    };
  }, [
    handleNavigateToItem,
    activeItem,
    selectedCapabilities,
    capabilitySet,
    capabilitySets,
    onSelectCapability,
    onDeselectCapability,
    onSelectCapabilities,
    onDeselectCapabilities,
  ]);

  return (
    <Modal
      size="xl"
      toggle={() => {}}
      className={styles.selector}
      centered
      isOpen
    >
      <ModalHeader>Choose your capabililities</ModalHeader>
      <SelectorContext.Provider value={selectorContext}>
        <ModalBody>
          <div className={styles['main-panels']}>
            <section className={styles.tree}>
              <CapabilityTree />
            </section>
            <section className={styles.details}>
              <CapabilityPicker />
            </section>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className={styles['selected-capabilities']}>
            <SelectedCapabilities />
          </div>
          <div className={styles['selector-controls']}>
            <Button color="primary" onClick={onClose}>
              OK
            </Button>
          </div>
        </ModalFooter>
      </SelectorContext.Provider>
    </Modal>
  );
}

export default CapabilitySelector;
